const InitialState = {
  signIn: false,
  username: "",
  userid: "",
  userType: "",
  mainuserid: "",
  parentid: "",
  companyid: "",
  secret: "",
  UIP: "",
  taskfilter:"",
  tasktype:"",
  taskname:"",
  grouping:""
};

const login = (state = InitialState, { type, payload }) => {
  let newState = {};
  switch (type) {
    case "sign_in":
      newState = {
        // ...state,
        signIn: true,
        username: payload.markingcode,
        userid: payload._id,
        userType: payload.type,
        mainuserid: payload.mainuserid,
        parentid: payload.parentid,
        companyid:payload.companyid,
        secret: payload.secret,
        nickname: payload.markingcode,
        department :payload.department ? payload.department : "",
        grouping : payload.grouping ? payload.grouping : "",
        UIP: payload.UIP,
        taskfilter:"all",
        tasktype:0
      };
      break;
    case "sign_out":
      newState = InitialState
      break;
    case "IPchanged":
      newState = {
        ...state,
        UIP: payload === undefined ? "" : payload.UIP
      };
      break;
    case "dashboard1":
      newState={
        ...state,
        taskfilter:payload.taskfilter,
        tasktype:payload.tasktype
      }
      case "dashboard2":
      newState={
        ...state,
        taskname:payload.taskname
      }
      break;
    default:
      newState = state
  }
  return newState;
};

export default login;
